import { gtmPushEvent } from '~/helpers/gtm';

function classHide(className) {
  className.forEach(function (classItem) {
    classItem.style.display = 'none';
  });
}
function classShow(className) {
  className.forEach(function (classItem) {
    classItem.style.display = 'block';
  });
}

const authUserFields = (user) => {
  if (user.value) {
    document.easiform.fld_FirstName.value = user.value.firstName;
    document.easiform.fld_FirstName.readOnly = true;
    document.easiform.fld_LastName.value = user.value.lastName;
    document.easiform.fld_LastName.readOnly = true;
    document.easiform.fld_Email.value = user.value.email;
    document.easiform.fld_Email.readOnly = true;
  } else {
    document.easiform.fld_FirstName.value = '';
    document.easiform.fld_LastName.value = '';
    document.easiform.fld_Email.value = '';
  }
};

const contactForm = {
  fr(user) {
    const checkExist = setInterval(function () {
      if (document.querySelectorAll('.easiform').length) {
        document.easiform.fld_CS_RequestObject.value = '';
        document.easiform.fld_CS_OrderId.value = '';
        document.easiform.fld_CS_Product1MagentoCode.value = '';
        document.easiform.fld_CS_Product1NameAndCapacity.value = '';
        document.easiform.fld_CS_Product1Batch.value = '';
        document.easiform.fld_CS_Product1Quantity.value = '';
        document.easiform.fld_CS_Catalog.value = '';
        document.easiform.fld_CS_MediaNotes.value = '';
        document.querySelector('#easi_fieldlabel_CS_MediaNotes').textContent = 'Site Web / Réseau social';
        document.easiform.fld_Description.setAttribute('maxlength', '502');
        document
          .querySelector('#validatebutton')
          .insertAdjacentHTML(
            'beforeBegin',
            '<button id="validatebuttonTemp" class="validatebutton">' +
              document.querySelector('#validatebutton').textContent +
              '</button>',
          );
        document.querySelector('#validatebutton').style.display = 'none';
        authUserFields(user);
        document.getElementById('validatebuttonTemp').addEventListener('click', function (e) {
          const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,25})+$/;
          if (
            document.easiform.fld_Email.value.match(mailformat) &&
            document.easiform.fld_FirstName.value != '' &&
            document.easiform.fld_LastName.value != '' &&
            document.easiform.fld_CS_RequestObject.value != '' &&
            document.easiform.fld_Description.value != ''
          ) {
            if (document.easiform.fld_CS_OrderId.value != '') {
              document.easiform.fld_CS_RequestObject.value =
                'Commmande : ' +
                document.easiform.fld_CS_OrderId.value +
                ' / ' +
                document.easiform.fld_CS_RequestObject.value;
            }
            if (document.easiform.fld_CS_Product1NameAndCapacity.value != '') {
              document.easiform.fld_Description.value =
                'Produit : ' +
                document.easiform.fld_CS_Product1NameAndCapacity.value +
                ' /\r\n ' +
                document.easiform.fld_Description.value;
            }
            const userData = {
              email: document.easiform.fld_Email.value,
              firstName: document.easiform.fld_FirstName.value,
              lastName: document.easiform.fld_LastName.value,
              requestObject: document.easiform.fld_CS_RequestObject.value,
              description: document.easiform.fld_Description.value,
            };

            gtmPushEvent('form', {
              event_category: 'form',
              event_action: 'submit',
              event_label: 'submit_contact',
              event_name: 'submit_contact',
              user_data: userData,
            });

            document.querySelector('#validatebuttonTemp').style.display = 'none';
            document.querySelector('#validatebutton').click();
            document.querySelector('#introSC').style.display = 'none';
            document.querySelector('#categoriesSC').style.display = 'none';
            document.querySelector('#subcategoriesSC').style.display = 'none';
            document.querySelector('#introsubcatSC').style.display = 'none';
            document.querySelector('#introformSC').style.display = 'none';
            window.scrollTo(0, 0);
            window.history.replaceState(null, null, '?form=sent');
            document.querySelector('#easiformmessages').textContent = '';
          } else {
            document.querySelector('#easiformmessages').textContent =
              '⚠Veuillez saisir les champs obligatoires (*) afin de prendre en compte votre demande';
          }
        });
        clearInterval(checkExist);
      }
    }, 100);

    const Cat =
      '[{"fCategory":"91","NameFR":"J\'ai une question sur la livraison ou le retour de ma commande"},{"fCategory":"92","NameFR":"J\'ai reçu ma commande mais quelque chose ne va pas"},{"fCategory":"93","NameFR":"J\'ai des questions sur mon produit"},{"fCategory":"94","NameFR":"J\'ai un besoin de conseil"},{"fCategory":"95","NameFR":"J\'ai un besoin professionnel"},{"fCategory":"96","NameFR":"J\'ai un besoin d’assistance sur le site ou en boutique/atelier"},{"fCategory":"97","NameFR":"J\'ai une question sur la marque"}]';

    if (document.readyState !== 'loading') {
      const sCat =
        '[{"fSubCategory":"98","NameFR":"Mon colis n\'est pas encore expédié","Parent":"91"},{"fSubCategory":"99","NameFR":"Mon adresse est erronée","Parent":"91"},{"fSubCategory":"100","NameFR":"Mon colis est noté livré mais je ne l\'ai pas reçu","Parent":"91"},{"fSubCategory":"101","NameFR":"La livraison de mon colis a échoué","Parent":"91"},{"fSubCategory":"102","NameFR":"Mon colis est bloqué","Parent":"91"},{"fSubCategory":"103","NameFR":"Mon colis fait retour","Parent":"91"},{"fSubCategory":"104","NameFR":"Formulaire de rétractation","Parent":"91"},{"fSubCategory":"105","NameFR":"Mon colis est endommagé","Parent":"92"},{"fSubCategory":"106","NameFR":"Produits manquants ou erronés","Parent":"92"},{"fSubCategory":"107","NameFR":"Produits cassés","Parent":"92"},{"fSubCategory":"108","NameFR":"Des produits ont fui","Parent":"92"},{"fSubCategory":"109","NameFR":"Mon produit semble défectueux","Parent":"93"},{"fSubCategory":"110","NameFR":"Mon appareil ne fonctionne pas","Parent":"93"},{"fSubCategory":"111","NameFR":"J\'ai une question sur odeur ou texture de mon produit","Parent":"93"},{"fSubCategory":"112","NameFR":"J\'ai une question sur l\'utilisation de mon produit ou de mon ingrédient","Parent":"93"},{"fSubCategory":"136","NameFR":"Retrouver un produit sur le site et connaître sa disponibilité","Parent":"93"},{"fSubCategory":"113","NameFR":"J\'ai une question sur la réalisation de ma recette","Parent":"93"},{"fSubCategory":"84","NameFR":"Mon produit n\'est pas confortable ou j\'ai fait une réaction","Parent":"93"},{"fSubCategory":"115","NameFR":"Demande de documents techniques","Parent":"93"},{"fSubCategory":"116","NameFR":"Cheveux","Parent":"94"},{"fSubCategory":"117","NameFR":"Nutrition – Bien-être","Parent":"94"},{"fSubCategory":"118","NameFR":"Huiles essentielles","Parent":"94"},{"fSubCategory":"119","NameFR":"Peau","Parent":"94"},{"fSubCategory":"120","NameFR":"Maman & Enfants","Parent":"94"},{"fSubCategory":"121","NameFR":"Recettes, dosage et utilisation des ingrédients","Parent":"94"},{"fSubCategory":"122","NameFR":"Appareils, flacons, accessoires","Parent":"94"},{"fSubCategory":"123","NameFR":"Maison","Parent":"94"},{"fSubCategory":"124","NameFR":"Animaux","Parent":"94"},{"fSubCategory":"126","NameFR":"Mon colis n\'est pas encore expédié","Parent":"95"},{"fSubCategory":"127","NameFR":"Mon adresse est erronée","Parent":"95"},{"fSubCategory":"128","NameFR":"Mon colis est noté livré mais je ne l\'ai pas reçu","Parent":"95"},{"fSubCategory":"129","NameFR":"La livraison de mon colis a échoué","Parent":"95"},{"fSubCategory":"130","NameFR":"Mon colis est bloqué","Parent":"95"},{"fSubCategory":"131","NameFR":"Mon colis fait retour","Parent":"95"},{"fSubCategory":"132","NameFR":"Connexion","Parent":"96"},{"fSubCategory":"133","NameFR":"Question sur le paiement de ma commande","Parent":"96"},{"fSubCategory":"134","NameFR":"Codes, fidélité et parrainage","Parent":"96"},{"fSubCategory":"135","NameFR":"Bug, Lien cassé, erreur d\'affichage, commande impossible","Parent":"96"},{"fSubCategory":"137","NameFR":"Conditions de livraisons","Parent":"96"},{"fSubCategory":"138","NameFR":"Désabonnement newsletter et données personnelles","Parent":"96"},{"fSubCategory":"139","NameFR":"Ateliers","Parent":"96"},{"fSubCategory":"156","NameFR":"Utiliser ma carte cadeau sur le site","Parent":"96"},{"fSubCategory":"140","NameFR":"Recrutement, candidature","Parent":"97"},{"fSubCategory":"141","NameFR":"Influence, media, presse","Parent":"97"},{"fSubCategory":"142","NameFR":"J\'utilise vos produits en tant que professionnel","Parent":"97"},{"fSubCategory":"143","NameFR":"Je souhaite vous proposer des produits en tant que Fournisseur","Parent":"97"},{"fSubCategory":"144","NameFR":"Je souhaite vous faire part de mon projet","Parent":"97"}]';
      const sCatFields =
        '[{"fSubCategory":"98","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"99","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"100","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"101","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"102","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"103","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"104","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"105","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"106","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"107","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"108","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"109","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"110","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"111","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"112","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"136","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"113","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"84","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"115","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"116","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"117","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"118","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"119","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"120","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"121","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"122","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"123","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"124","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"126","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"127","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"128","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"129","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"130","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"131","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"132","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"133","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"134","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"135","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"137","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"138","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"139","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"156","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"140","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"141","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"142","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"143","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"144","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"}]';
      const arrCat = JSON.parse(Cat);
      const arrsCat = JSON.parse(sCat);
      const arrsCatFields = JSON.parse(sCatFields);
      arrCat.forEach(function (c) {
        document
          .querySelector('#categoriesSC')
          .insertAdjacentHTML(
            'beforeend',
            '<span class="categorySC" id="categorySC' +
              c.fCategory +
              '" data-id="' +
              c.fCategory +
              '" label="' +
              c.NameFR +
              '">' +
              c.NameFR +
              '</span>',
          );
        document
          .querySelector('#subcategoriesSC')
          .insertAdjacentHTML('beforeend', '<div class="sbcategoriesSC" id="subcategorySC' + c.fCategory + '" ></div>');
      });
      arrsCat.forEach(function (s) {
        document
          .querySelector('#subcategorySC' + s.Parent)
          .insertAdjacentHTML(
            'beforeend',
            '<span class="subcategorySC" id="subcategorySC' +
              s.fSubCategory.replace('.', '_') +
              '" data-id="' +
              s.fSubCategory +
              '" label="' +
              s.NameFR +
              '" style="display:none;">' +
              s.NameFR +
              '</span>',
          );
        if (s.Articles) {
          document
            .querySelector('#introformSC')
            .insertAdjacentHTML(
              'beforeend',
              '<ul class="articlesSC" id="articlesSC' + s.fSubCategory.replace('.', '_') + '"></ul>',
            );
          s.Articles.forEach(function (a) {
            document
              .querySelector('#articlesSC' + s.fSubCategory.replace('.', '_'))
              .insertAdjacentHTML(
                'beforeend',
                '<li class="articleSC" id="kbid_' +
                  a.kbid +
                  '"><a href="' +
                  a.url +
                  '" target="_blank">' +
                  a.title.replace(' ?', '&nbsp;?') +
                  '</a></li>',
              );
          });
        }
      });
      document.querySelector('#categoriesSC').style.display = 'block';
      const scategoriesSC = document.getElementById('categoriesSC').children;
      for (let i = 0; i < scategoriesSC.length; i++) {
        scategoriesSC[i].style.display = 'block';
      }
      const zoomMobile = 1;
      document.querySelector('#introSC').addEventListener('click', (e) => {
        document.querySelector('#introsubcatSC').style.display = 'none';
        classHide(document.querySelectorAll('.articlesSC'));
        classShow(document.querySelectorAll('.categorySC'));
        classHide(document.querySelectorAll('span.subcategorySC'));
        document.querySelector('#introformSC').style.display = 'none';
        document.querySelector('#easiformarea').style.display = 'none';
      });
      const itemsArr = document.querySelectorAll('span.categorySC');
      for (let index = 0; index < itemsArr.length; index++) {
        itemsArr[index].addEventListener('click', function (e) {
          document.querySelector('#introsubcatSC').style.display = 'block';
          document.querySelector('#easiformarea').style.display = 'none';
          classHide(document.querySelectorAll('.articlesSC'));
          classHide(document.querySelectorAll('.categorySC'));
          e.target.style.display = 'block';
          document.querySelector('#sub' + e.target.getAttribute('id')).style.display = 'block';
          const subcategoriesSC = document.getElementById('sub' + e.target.getAttribute('id')).childNodes;
          for (let i = 0; i < subcategoriesSC.length; i++) {
            subcategoriesSC[i].style.display = 'none';
            subcategoriesSC[i].style.display = 'block';
          }
          window.scrollTo(
            0,
            Math.round(
              (document.querySelector('#introsubcatSC').getBoundingClientRect().top + window.scrollY) * zoomMobile,
            ),
          );
          if (document.getElementById('fld_Category')) {
            document.getElementById('fld_Category').value = e.target.getAttribute('data-id');
          }
          document.querySelector('#introformSC').style.display = 'none';
        });
      }
      const itemsArr2 = document.querySelectorAll('span.subcategorySC');
      for (let index2 = 0; index2 < itemsArr2.length; index2++) {
        itemsArr2[index2].addEventListener('click', function (e) {
          if (e.target.getAttribute('data-id') == 140) {
            document.location.replace('https://www.aroma-zone.com/content/recrutement');
            return;
          }
          document.querySelector('#introformSC').style.display = 'block';
          if (document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_'))) {
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'none';
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'block';
            document.querySelector('#textFaqintroformSC').style.display = 'block';
          } else {
            document.querySelector('#textFaqintroformSC').style.display = 'none';
          }
          document.querySelector('#easiformarea').style.display = 'block';
          classHide(document.querySelectorAll('.subcategorySC'));
          document.querySelector('#easi_fielddiv_Category').style.display = 'none';
          document.querySelector('#easi_fielddiv_SubCategory').style.display = 'none';

          e.target.style.display = 'block';
          window.scrollTo(
            0,
            Math.round(
              window.scrollY + document.querySelector('#introformSC').getBoundingClientRect().top * zoomMobile,
            ),
          );
          document
            .querySelector('#fld_SubCategory')
            .add(new Option(e.target.getAttribute('label'), e.target.getAttribute('data-id')));
          document.easiform.fld_SubCategory.value = e.target.getAttribute('data-id');
          const fld_SubCategory = e.target.getAttribute('data-id');
          arrsCatFields.forEach(function (s) {
            if (s.fSubCategory == fld_SubCategory) {
              if (s.OrderId == 1) {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'none';
              }
              if (s.Product1MagentoCode == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'none';
              }
              if (s.Product1NameAndCapacity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'none';
              }
              if (s.Product1Batch == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'none';
              }
              if (s.Product1Quantity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'none';
              }
              if (s.Catalog == 1) {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'none';
              }
              if (s.MediaNotes == 1) {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'none';
              }
            }
          });
        });
      }
    }
  },

  it(user) {
    const checkExist = setInterval(function () {
      if (document.querySelectorAll('.easiform').length) {
        document.easiform.fld_CS_RequestObject.value = '';
        document.easiform.fld_CS_OrderId.value = '';
        document.easiform.fld_CS_Product1MagentoCode.value = '';
        document.easiform.fld_CS_Product1NameAndCapacity.value = '';
        document.easiform.fld_CS_Product1Batch.value = '';
        document.easiform.fld_CS_Product1Quantity.value = '';
        document.easiform.fld_CS_Catalog.value = '';
        document.easiform.fld_CS_MediaNotes.value = '';
        document.querySelector('#easi_fieldlabel_FirstName').textContent = 'Cognome';
        document.querySelector('#easi_fieldlabel_LastName').textContent = 'Nome';
        document.querySelector('#easi_fieldlabel_Email').textContent = 'Email';
        document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Titolo della domanda';
        document.querySelector('#easi_fieldlabel_Description').textContent = 'Descrizione';
        document.querySelector('#easi_fieldlabel_CS_OrderId').textContent = "Numero dell'ordine";
        document.querySelector('#easi_fieldlabel_CS_Product1MagentoCode').textContent = 'Referenza articolo';
        document.querySelector('#easi_fieldlabel_CS_Product1NameAndCapacity').textContent =
          "Formulazione e contenuto dell'articolo";
        document.querySelector('#easi_fieldlabel_CS_Product1Batch').textContent = "Numero di lotto dell'articolo";
        document.querySelector('#easi_fieldlabel_CS_Product1Quantity').textContent = 'Quantità articoli';
        document.querySelector('#easi_fieldlabel_AttachedFiles').textContent = 'Allegati';
        document.querySelector('#easi_fieldlabel_CS_MediaNotes').textContent = 'Indirizzo Url/conto';
        document.querySelector('#validatebutton').textContent = 'Inviare la mia domanda';
        document.querySelector('#mandatoryfieldmention').textContent = '* Campi obbligatori';
        authUserFields(user);
        document.easiform.fld_Description.setAttribute('maxlength', '500');
        document
          .querySelector('#validatebutton')
          .insertAdjacentHTML(
            'beforeBegin',
            '<button id="validatebuttonTemp" class="validatebutton">' +
              document.querySelector('#validatebutton').textContent +
              '</button>',
          );
        document.querySelector('#validatebutton').style.display = 'none';
        document.getElementById('validatebuttonTemp').addEventListener('click', function (e) {
          const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,25})+$/;
          if (
            document.easiform.fld_Email.value.match(mailformat) &&
            document.easiform.fld_FirstName.value != '' &&
            document.easiform.fld_LastName.value != '' &&
            document.easiform.fld_CS_RequestObject.value != '' &&
            document.easiform.fld_Description.value != ''
          ) {
            const userData = {
              email: document.easiform.fld_Email.value,
              firstName: document.easiform.fld_FirstName.value,
              lastName: document.easiform.fld_LastName.value,
              requestObject: document.easiform.fld_CS_RequestObject.value,
              description: document.easiform.fld_Description.value,
            };

            gtmPushEvent('form', {
              event_category: 'form',
              event_action: 'submit',
              event_label: 'submit_contact',
              event_name: 'submit_contact',
              user_data: userData,
            });

            if (document.easiform.fld_CS_OrderId.value != '') {
              document.easiform.fld_CS_RequestObject.value =
                'Ordine : ' +
                document.easiform.fld_CS_OrderId.value +
                ' / ' +
                document.easiform.fld_CS_RequestObject.value;
            }
            if (document.easiform.fld_CS_Product1NameAndCapacity.value != '') {
              document.easiform.fld_Description.value =
                'Articolo : ' +
                document.easiform.fld_CS_Product1NameAndCapacity.value +
                ' /\r\n ' +
                document.easiform.fld_Description.value;
            }
            document.querySelector('#validatebuttonTemp').style.display = 'none';
            document.querySelector('#validatebutton').click();
            document.querySelector('#introSC').style.display = 'none';
            document.querySelector('#categoriesSC').style.display = 'none';
            document.querySelector('#subcategoriesSC').style.display = 'none';
            document.querySelector('#introsubcatSC').style.display = 'none';
            document.querySelector('#introformSC').style.display = 'none';
            window.history.replaceState(null, null, '?form=sent');
            document.querySelector('#easiformmessages').textContent = '';
          } else {
            document.querySelector('#easiformmessages').textContent =
              '⚠Compila tutti i campi obbligatori (*) per permetterci di prendere in carico la tua richiesta, grazie';
          }
        });
        clearInterval(checkExist);
      }
    }, 100);

    const Cat = '[{"fCategory":"146","NameFR":"Motivi Italiani"}]';
    if (document.readyState !== 'loading') {
      const sCat =
        '[{"fSubCategory":"147","NameFR":"Ho una domanda sulla consegna o il reso del mio ordine","Parent":"146"},{"fSubCategory":"148","NameFR":"Ho ricevuto il mio ordine ma c\'è un problema","Parent":"146"},{"fSubCategory":"149","NameFR":"Domande sul mio prodotto","Parent":"146"},{"fSubCategory":"150","NameFR":"Ho bisogno di un consiglio","Parent":"146"},{"fSubCategory":"151","NameFR":"Ho bisogno come professionista","Parent":"146"},{"fSubCategory":"152","NameFR":"Ho bisogno di assistenza sul sito","Parent":"146"},{"fSubCategory":"153","NameFR":"Domanda sulla marca","Parent":"146"}]';
      const sCatFields =
        '[{"fSubCategory":"147","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"148","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"149","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"150","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"151","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"152","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"153","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"}]';
      const arrCat = JSON.parse(Cat);
      const arrsCat = JSON.parse(sCat);
      const arrsCatFields = JSON.parse(sCatFields);
      arrCat.forEach(function (c) {
        document
          .querySelector('#categoriesSC')
          .insertAdjacentHTML(
            'beforeend',
            '<span class="categorySC" id="categorySC' +
              c.fCategory +
              '" data-id="' +
              c.fCategory +
              '" label="' +
              c.NameFR +
              '">' +
              c.NameFR +
              '</span>',
          );
        document
          .querySelector('#subcategoriesSC')
          .insertAdjacentHTML('beforeend', '<div class="sbcategoriesSC" id="subcategorySC' + c.fCategory + '" ></div>');
      });
      arrsCat.forEach(function (s) {
        document
          .querySelector('#subcategorySC' + s.Parent)
          .insertAdjacentHTML(
            'beforeend',
            '<span class="subcategorySC" id="subcategorySC' +
              s.fSubCategory.replace('.', '_') +
              '" data-id="' +
              s.fSubCategory +
              '" label="' +
              s.NameFR +
              '" style="display:none;">' +
              s.NameFR +
              '</span>',
          );
        if (s.Articles) {
          document
            .querySelector('#introformSC')
            .insertAdjacentHTML(
              'beforeend',
              '<ul class="articlesSC" id="articlesSC' + s.fSubCategory.replace('.', '_') + '"></ul>',
            );
          s.Articles.forEach(function (a) {
            document
              .querySelector('#articlesSC' + s.fSubCategory.replace('.', '_'))
              .insertAdjacentHTML(
                'beforeend',
                '<li class="articleSC" id="kbid_' +
                  a.kbid +
                  '"><a href="' +
                  a.url +
                  '" target="_blank">' +
                  a.title.replace(' ?', '&nbsp;?') +
                  '</a></li>',
              );
          });
        }
      });

      document.querySelector('#categoriesSC').style.display = 'block';
      const scategoriesSC = document.getElementById('categoriesSC').children;
      for (let i = 0; i < scategoriesSC.length; i++) {
        scategoriesSC[i].style.display = 'block';
      }
      document.querySelector('#introSC').style.display = 'none';
      document.querySelector('#categoriesSC').style.display = 'none';
      const zoomMobile = 1;
      document.querySelector('#introsubcatSC').addEventListener('click', (e) => {
        classHide(document.querySelectorAll('.articlesSC'));
        classShow(document.querySelectorAll('.categorySC'));
        classShow(document.querySelectorAll('span.subcategorySC'));
        document.querySelector('#introformSC').style.display = 'none';
        document.querySelector('#easiformarea').style.display = 'none';
      });
      const itemsArr = document.querySelectorAll('span.categorySC');
      for (let index = 0; index < itemsArr.length; index++) {
        itemsArr[index].addEventListener('click', function (e) {
          document.querySelector('#introsubcatSC').style.display = 'block';
          document.querySelector('#easiformarea').style.display = 'none';
          classHide(document.querySelectorAll('.articlesSC'));
          classHide(document.querySelectorAll('.categorySC'));
          e.target.style.display = 'block';
          document.querySelector('#sub' + e.target.getAttribute('id')).style.display = 'block';
          const subcategoriesSC = document.getElementById('sub' + e.target.getAttribute('id')).childNodes;
          for (let i = 0; i < subcategoriesSC.length; i++) {
            subcategoriesSC[i].style.display = 'none';
            subcategoriesSC[i].style.display = 'block';
          }
          if (document.getElementById('fld_Category')) {
            document.getElementById('fld_Category').value = e.target.getAttribute('data-id');
          }
          document.querySelector('#introformSC').style.display = 'none';
        });
      }
      document.querySelector('#categoriesSC span.categorySC').click();
      const itemsArr2 = document.querySelectorAll('span.subcategorySC');
      for (let index2 = 0; index2 < itemsArr2.length; index2++) {
        itemsArr2[index2].addEventListener('click', function (e) {
          if (e.target.getAttribute('data-id') == 140) {
            document.location.replace('https://www.aroma-zone.com/content/recrutement');
            return;
          }
          document.querySelector('#introformSC').style.display = 'block';
          if (document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_'))) {
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'none';
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'block';
            document.querySelector('#textFaqintroformSC').style.display = 'block';
          } else {
            document.querySelector('#textFaqintroformSC').style.display = 'none';
          }
          document.querySelector('#easiformarea').style.display = 'block';
          classHide(document.querySelectorAll('.subcategorySC'));
          document.querySelector('#easi_fielddiv_Category').style.display = 'none';
          document.querySelector('#easi_fielddiv_SubCategory').style.display = 'none';

          e.target.style.display = 'block';
          window.scrollTo(
            0,
            Math.round(
              window.scrollY + document.querySelector('#introformSC').getBoundingClientRect().top * zoomMobile,
            ),
          );
          document
            .querySelector('#fld_SubCategory')
            .add(new Option(e.target.getAttribute('label'), e.target.getAttribute('data-id')));
          document.easiform.fld_SubCategory.value = e.target.getAttribute('data-id');
          const fld_SubCategory = e.target.getAttribute('data-id');
          arrsCatFields.forEach(function (s) {
            if (s.fSubCategory == fld_SubCategory) {
              if (s.OrderId == 1) {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'none';
              }
              if (s.Product1MagentoCode == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'none';
              }
              if (s.Product1NameAndCapacity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'none';
              }
              if (s.Product1Batch == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'none';
              }
              if (s.Product1Quantity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'none';
              }
              if (s.Catalog == 1) {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'none';
              }
              if (s.MediaNotes == 1) {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'none';
              }
            }
          });
        });
      }
    }
  },

  en(user) {
    const checkExist = setInterval(function () {
      if (document.querySelectorAll('.easiform').length) {
        document.easiform.fld_CS_RequestObject.value = '';
        document.easiform.fld_CS_OrderId.value = '';
        document.easiform.fld_CS_Product1MagentoCode.value = '';
        document.easiform.fld_CS_Product1NameAndCapacity.value = '';
        document.easiform.fld_CS_Product1Batch.value = '';
        document.easiform.fld_CS_Product1Quantity.value = '';
        document.easiform.fld_CS_Catalog.value = '';
        document.easiform.fld_CS_MediaNotes.value = '';
        document.querySelector('#easi_fieldlabel_FirstName').textContent = 'First name';
        document.querySelector('#easi_fieldlabel_LastName').textContent = 'Last Name';
        document.querySelector('#easi_fieldlabel_Email').textContent = 'Email';
        document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Request title';
        document.querySelector('#easi_fieldlabel_Description').textContent = 'Description';
        document.querySelector('#easi_fieldlabel_CS_OrderId').textContent = 'Order number';
        document.querySelector('#easi_fieldlabel_CS_Product1MagentoCode').textContent = 'Product reference (SKU)';
        document.querySelector('#easi_fieldlabel_CS_Product1NameAndCapacity').textContent = 'Product name';
        document.querySelector('#easi_fieldlabel_CS_Product1Batch').textContent = 'Product batch number';
        document.querySelector('#easi_fieldlabel_CS_Product1Quantity').textContent = 'Product quantity';
        document.querySelector('#easi_fieldlabel_AttachedFiles').textContent = 'Attached files';
        document.querySelector('#easi_fieldlabel_CS_MediaNotes').textContent = 'Website / Social Network';
        document.querySelector('#validatebutton').textContent = 'Send Request';
        document.querySelector('#mandatoryfieldmention').textContent = '* Required fields';
        authUserFields(user);
        document.easiform.fld_Description.setAttribute('maxlength', '500');
        document
          .querySelector('#validatebutton')
          .insertAdjacentHTML(
            'beforeBegin',
            '<button id="validatebuttonTemp" class="validatebutton">' +
              document.querySelector('#validatebutton').textContent +
              '</button>',
          );
        document.querySelector('#validatebutton').style.display = 'none';
        document.getElementById('validatebuttonTemp').addEventListener('click', function (e) {
          const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,25})+$/;
          if (
            document.easiform.fld_Email.value.match(mailformat) &&
            document.easiform.fld_FirstName.value != '' &&
            document.easiform.fld_LastName.value != '' &&
            document.easiform.fld_CS_RequestObject.value != '' &&
            document.easiform.fld_Description.value != ''
          ) {
            const userData = {
              email: document.easiform.fld_Email.value,
              firstName: document.easiform.fld_FirstName.value,
              lastName: document.easiform.fld_LastName.value,
              requestObject: document.easiform.fld_CS_RequestObject.value,
              description: document.easiform.fld_Description.value,
            };

            gtmPushEvent('form', {
              event_category: 'form',
              event_action: 'submit',
              event_label: 'submit_contact',
              event_name: 'submit_contact',
              user_data: userData,
            });

            if (document.easiform.fld_CS_OrderId.value != '') {
              document.easiform.fld_CS_RequestObject.value =
                'Ordine : ' +
                document.easiform.fld_CS_OrderId.value +
                ' / ' +
                document.easiform.fld_CS_RequestObject.value;
            }
            if (document.easiform.fld_CS_Product1NameAndCapacity.value != '') {
              document.easiform.fld_Description.value =
                'Articolo : ' +
                document.easiform.fld_CS_Product1NameAndCapacity.value +
                ' /\r\n ' +
                document.easiform.fld_Description.value;
            }
            document.querySelector('#validatebuttonTemp').style.display = 'none';
            document.querySelector('#validatebutton').click();
            document.querySelector('#introSC').style.display = 'none';
            document.querySelector('#categoriesSC').style.display = 'none';
            document.querySelector('#subcategoriesSC').style.display = 'none';
            document.querySelector('#introsubcatSC').style.display = 'none';
            document.querySelector('#introformSC').style.display = 'none';
            window.history.replaceState(null, null, '?form=sent');
            document.querySelector('#easiformmessages').textContent = '';
          } else {
            document.querySelector('#easiformmessages').textContent =
              '⚠ Please fill in the required fields (*) in order to take your request into account';
          }
        });
        clearInterval(checkExist);
      }
    }, 100);

    const Cat = '[{"fCategory":"157","NameFR":"English requests"}]';
    if (document.readyState !== 'loading') {
      const sCat =
        '[{"fSubCategory":"158","NameFR":"I have a question about my order\'s shipment or return","Parent":"157"},{"fSubCategory":"159","NameFR":"I received my order but something is wrong","Parent":"157"},{"fSubCategory":"160","NameFR":"I have questions about my product","Parent":"157"},{"fSubCategory":"161","NameFR":"I need advice","Parent":"157"},{"fSubCategory":"162","NameFR":"I have a professional need","Parent":"157"},{"fSubCategory":"163","NameFR":"I need assistance on the website or in store","Parent":"157"},{"fSubCategory":"164","NameFR":"I have a question about the brand","Parent":"157"}]';
      const sCatFields =
        '[{"fSubCategory":"158","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"159","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"160","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"161","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"162","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"163","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"164","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"}]';
      const arrCat = JSON.parse(Cat);
      const arrsCat = JSON.parse(sCat);
      const arrsCatFields = JSON.parse(sCatFields);
      arrCat.forEach(function (c) {
        document
          .querySelector('#categoriesSC')
          .insertAdjacentHTML(
            'beforeend',
            '<span class="categorySC" id="categorySC' +
              c.fCategory +
              '" data-id="' +
              c.fCategory +
              '" label="' +
              c.NameFR +
              '">' +
              c.NameFR +
              '</span>',
          );
        document
          .querySelector('#subcategoriesSC')
          .insertAdjacentHTML('beforeend', '<div class="sbcategoriesSC" id="subcategorySC' + c.fCategory + '" ></div>');
      });
      arrsCat.forEach(function (s) {
        document
          .querySelector('#subcategorySC' + s.Parent)
          .insertAdjacentHTML(
            'beforeend',
            '<span class="subcategorySC" id="subcategorySC' +
              s.fSubCategory.replace('.', '_') +
              '" data-id="' +
              s.fSubCategory +
              '" label="' +
              s.NameFR +
              '" style="display:none;">' +
              s.NameFR +
              '</span>',
          );
        if (s.Articles) {
          document
            .querySelector('#introformSC')
            .insertAdjacentHTML(
              'beforeend',
              '<ul class="articlesSC" id="articlesSC' + s.fSubCategory.replace('.', '_') + '"></ul>',
            );
          s.Articles.forEach(function (a) {
            document
              .querySelector('#articlesSC' + s.fSubCategory.replace('.', '_'))
              .insertAdjacentHTML(
                'beforeend',
                '<li class="articleSC" id="kbid_' +
                  a.kbid +
                  '"><a href="' +
                  a.url +
                  '" target="_blank">' +
                  a.title.replace(' ?', '&nbsp;?') +
                  '</a></li>',
              );
          });
        }
      });

      document.querySelector('#categoriesSC').style.display = 'block';
      const scategoriesSC = document.getElementById('categoriesSC').children;
      for (let i = 0; i < scategoriesSC.length; i++) {
        scategoriesSC[i].style.display = 'block';
      }
      document.querySelector('#introSC').style.display = 'none';
      document.querySelector('#categoriesSC').style.display = 'none';
      const zoomMobile = 1;
      document.querySelector('#introsubcatSC').addEventListener('click', (e) => {
        classHide(document.querySelectorAll('.articlesSC'));
        classShow(document.querySelectorAll('.categorySC'));
        classShow(document.querySelectorAll('span.subcategorySC'));
        document.querySelector('#introformSC').style.display = 'none';
        document.querySelector('#easiformarea').style.display = 'none';
      });
      const itemsArr = document.querySelectorAll('span.categorySC');
      for (let index = 0; index < itemsArr.length; index++) {
        itemsArr[index].addEventListener('click', function (e) {
          document.querySelector('#introsubcatSC').style.display = 'block';
          document.querySelector('#easiformarea').style.display = 'none';
          classHide(document.querySelectorAll('.articlesSC'));
          classHide(document.querySelectorAll('.categorySC'));
          e.target.style.display = 'block';
          document.querySelector('#sub' + e.target.getAttribute('id')).style.display = 'block';
          const subcategoriesSC = document.getElementById('sub' + e.target.getAttribute('id')).childNodes;
          for (let i = 0; i < subcategoriesSC.length; i++) {
            subcategoriesSC[i].style.display = 'none';
            subcategoriesSC[i].style.display = 'block';
          }
          if (document.getElementById('fld_Category')) {
            document.getElementById('fld_Category').value = e.target.getAttribute('data-id');
          }
          document.querySelector('#introformSC').style.display = 'none';
        });
      }
      document.querySelector('#categoriesSC span.categorySC').click();
      const itemsArr2 = document.querySelectorAll('span.subcategorySC');
      for (let index2 = 0; index2 < itemsArr2.length; index2++) {
        itemsArr2[index2].addEventListener('click', function (e) {
          if (e.target.getAttribute('data-id') == 140) {
            document.location.replace('https://www.aroma-zone.com/content/recrutement');
            return;
          }
          document.querySelector('#introformSC').style.display = 'block';
          if (document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_'))) {
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'none';
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'block';
            document.querySelector('#textFaqintroformSC').style.display = 'block';
          } else {
            document.querySelector('#textFaqintroformSC').style.display = 'none';
          }
          document.querySelector('#easiformarea').style.display = 'block';
          classHide(document.querySelectorAll('.subcategorySC'));
          document.querySelector('#easi_fielddiv_Category').style.display = 'none';
          document.querySelector('#easi_fielddiv_SubCategory').style.display = 'none';

          e.target.style.display = 'block';
          window.scrollTo(
            0,
            Math.round(
              window.scrollY + document.querySelector('#introformSC').getBoundingClientRect().top * zoomMobile,
            ),
          );
          document
            .querySelector('#fld_SubCategory')
            .add(new Option(e.target.getAttribute('label'), e.target.getAttribute('data-id')));
          document.easiform.fld_SubCategory.value = e.target.getAttribute('data-id');
          const fld_SubCategory = e.target.getAttribute('data-id');
          arrsCatFields.forEach(function (s) {
            if (s.fSubCategory == fld_SubCategory) {
              if (s.OrderId == 1) {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'none';
              }
              if (s.Product1MagentoCode == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'none';
              }
              if (s.Product1NameAndCapacity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'none';
              }
              if (s.Product1Batch == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'none';
              }
              if (s.Product1Quantity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'none';
              }
              if (s.Catalog == 1) {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'none';
              }
              if (s.MediaNotes == 1) {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'none';
              }
            }
          });
        });
      }
    }
  },

  es(user) {
    const checkExist = setInterval(function () {
      if (document.querySelectorAll('.easiform').length) {
        document.easiform.fld_CS_RequestObject.value = '';
        document.easiform.fld_CS_OrderId.value = '';
        document.easiform.fld_CS_Product1MagentoCode.value = '';
        document.easiform.fld_CS_Product1NameAndCapacity.value = '';
        document.easiform.fld_CS_Product1Batch.value = '';
        document.easiform.fld_CS_Product1Quantity.value = '';
        document.easiform.fld_CS_Catalog.value = '';
        document.easiform.fld_CS_MediaNotes.value = '';
        document.querySelector('#easi_fieldlabel_FirstName').textContent = 'Nombre ';
        document.querySelector('#easi_fieldlabel_LastName').textContent = 'Apellido';
        document.querySelector('#easi_fieldlabel_Email').textContent = 'Correo electrónico';
        document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Título';
        document.querySelector('#easi_fieldlabel_Description').textContent = 'Descripción';
        document.querySelector('#easi_fieldlabel_CS_OrderId').textContent = 'Número de orden';
        document.querySelector('#easi_fieldlabel_CS_Product1MagentoCode').textContent = 'Referencia del producto (SKU)';
        document.querySelector('#easi_fieldlabel_CS_Product1NameAndCapacity').textContent = 'Nombre del producto';
        document.querySelector('#easi_fieldlabel_CS_Product1Batch').textContent = 'Número de lote del producto';
        document.querySelector('#easi_fieldlabel_CS_Product1Quantity').textContent = 'Cantidad de producto';
        document.querySelector('#easi_fieldlabel_AttachedFiles').textContent = 'Archivos añadidos ';
        document.querySelector('#easi_fieldlabel_CS_MediaNotes').textContent = 'Página web / Rede social';
        document.querySelector('#validatebutton').textContent = 'Enviar solicitud';
        document.querySelector('#mandatoryfieldmention').textContent = '* Campos obligatorios';
        authUserFields(user);
        document.easiform.fld_Description.setAttribute('maxlength', '500');
        document
          .querySelector('#validatebutton')
          .insertAdjacentHTML(
            'beforeBegin',
            '<button id="validatebuttonTemp" class="validatebutton">' +
              document.querySelector('#validatebutton').textContent +
              '</button>',
          );
        document.querySelector('#validatebutton').style.display = 'none';
        document.getElementById('validatebuttonTemp').addEventListener('click', function (e) {
          const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,25})+$/;
          if (
            document.easiform.fld_Email.value.match(mailformat) &&
            document.easiform.fld_FirstName.value != '' &&
            document.easiform.fld_LastName.value != '' &&
            document.easiform.fld_CS_RequestObject.value != '' &&
            document.easiform.fld_Description.value != ''
          ) {
            const userData = {
              email: document.easiform.fld_Email.value,
              firstName: document.easiform.fld_FirstName.value,
              lastName: document.easiform.fld_LastName.value,
              requestObject: document.easiform.fld_CS_RequestObject.value,
              description: document.easiform.fld_Description.value,
            };

            gtmPushEvent('form', {
              event_category: 'form',
              event_action: 'submit',
              event_label: 'submit_contact',
              event_name: 'submit_contact',
              user_data: userData,
            });

            if (document.easiform.fld_CS_OrderId.value != '') {
              document.easiform.fld_CS_RequestObject.value =
                'Ordine : ' +
                document.easiform.fld_CS_OrderId.value +
                ' / ' +
                document.easiform.fld_CS_RequestObject.value;
            }
            if (document.easiform.fld_CS_Product1NameAndCapacity.value != '') {
              document.easiform.fld_Description.value =
                'Articolo : ' +
                document.easiform.fld_CS_Product1NameAndCapacity.value +
                ' /\r\n ' +
                document.easiform.fld_Description.value;
            }
            document.querySelector('#validatebuttonTemp').style.display = 'none';
            document.querySelector('#validatebutton').click();
            document.querySelector('#introSC').style.display = 'none';
            document.querySelector('#categoriesSC').style.display = 'none';
            document.querySelector('#subcategoriesSC').style.display = 'none';
            document.querySelector('#introsubcatSC').style.display = 'none';
            document.querySelector('#introformSC').style.display = 'none';
            window.history.replaceState(null, null, '?form=sent');
            document.querySelector('#easiformmessages').textContent = '';
          } else {
            document.querySelector('#easiformmessages').textContent =
              '⚠ Por favor, rellene los campos obligatorios (*) para tener en cuenta su solicitud';
          }
        });
        clearInterval(checkExist);
      }
    }, 100);

    const Cat = '[{"fCategory":"173","NameFR":"Solicitudes españolas"}]';
    if (document.readyState !== 'loading') {
      const sCat =
        '[{"fSubCategory":"174","NameFR":"Tengo una pregunta sobre el envío o regreso de mi pedido","Parent":"173"},{"fSubCategory":"175","NameFR":"Recibí mi pedido pero algo anda mal","Parent":"173"},{"fSubCategory":"176","NameFR":"Tengo preguntas sobre mi producto","Parent":"173"},{"fSubCategory":"177","NameFR":"Necesito consejo","Parent":"173"},{"fSubCategory":"178","NameFR":"Tengo una necesidad profesional","Parent":"173"},{"fSubCategory":"179","NameFR":"Necesito ayuda en el sitio web o en la tienda","Parent":"173"},{"fSubCategory":"180","NameFR":"Tengo una pregunta sobre la marca","Parent":"173"}]';
      const sCatFields =
        '[{"fSubCategory":"174","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"175","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"176","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"177","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"178","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"179","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"180","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"}]';
      const arrCat = JSON.parse(Cat);
      const arrsCat = JSON.parse(sCat);
      const arrsCatFields = JSON.parse(sCatFields);
      arrCat.forEach(function (c) {
        document
          .querySelector('#categoriesSC')
          .insertAdjacentHTML(
            'beforeend',
            '<span class="categorySC" id="categorySC' +
              c.fCategory +
              '" data-id="' +
              c.fCategory +
              '" label="' +
              c.NameFR +
              '">' +
              c.NameFR +
              '</span>',
          );
        document
          .querySelector('#subcategoriesSC')
          .insertAdjacentHTML('beforeend', '<div class="sbcategoriesSC" id="subcategorySC' + c.fCategory + '" ></div>');
      });
      arrsCat.forEach(function (s) {
        document
          .querySelector('#subcategorySC' + s.Parent)
          .insertAdjacentHTML(
            'beforeend',
            '<span class="subcategorySC" id="subcategorySC' +
              s.fSubCategory.replace('.', '_') +
              '" data-id="' +
              s.fSubCategory +
              '" label="' +
              s.NameFR +
              '" style="display:none;">' +
              s.NameFR +
              '</span>',
          );
        if (s.Articles) {
          document
            .querySelector('#introformSC')
            .insertAdjacentHTML(
              'beforeend',
              '<ul class="articlesSC" id="articlesSC' + s.fSubCategory.replace('.', '_') + '"></ul>',
            );
          s.Articles.forEach(function (a) {
            document
              .querySelector('#articlesSC' + s.fSubCategory.replace('.', '_'))
              .insertAdjacentHTML(
                'beforeend',
                '<li class="articleSC" id="kbid_' +
                  a.kbid +
                  '"><a href="' +
                  a.url +
                  '" target="_blank">' +
                  a.title.replace(' ?', '&nbsp;?') +
                  '</a></li>',
              );
          });
        }
      });

      document.querySelector('#categoriesSC').style.display = 'block';
      const scategoriesSC = document.getElementById('categoriesSC').children;
      for (let i = 0; i < scategoriesSC.length; i++) {
        scategoriesSC[i].style.display = 'block';
      }
      document.querySelector('#introSC').style.display = 'none';
      document.querySelector('#categoriesSC').style.display = 'none';
      const zoomMobile = 1;
      document.querySelector('#introsubcatSC').addEventListener('click', (e) => {
        classHide(document.querySelectorAll('.articlesSC'));
        classShow(document.querySelectorAll('.categorySC'));
        classShow(document.querySelectorAll('span.subcategorySC'));
        document.querySelector('#introformSC').style.display = 'none';
        document.querySelector('#easiformarea').style.display = 'none';
      });
      const itemsArr = document.querySelectorAll('span.categorySC');
      for (let index = 0; index < itemsArr.length; index++) {
        itemsArr[index].addEventListener('click', function (e) {
          document.querySelector('#introsubcatSC').style.display = 'block';
          document.querySelector('#easiformarea').style.display = 'none';
          classHide(document.querySelectorAll('.articlesSC'));
          classHide(document.querySelectorAll('.categorySC'));
          e.target.style.display = 'block';
          document.querySelector('#sub' + e.target.getAttribute('id')).style.display = 'block';
          const subcategoriesSC = document.getElementById('sub' + e.target.getAttribute('id')).childNodes;
          for (let i = 0; i < subcategoriesSC.length; i++) {
            subcategoriesSC[i].style.display = 'none';
            subcategoriesSC[i].style.display = 'block';
          }
          if (document.getElementById('fld_Category')) {
            document.getElementById('fld_Category').value = e.target.getAttribute('data-id');
          }
          document.querySelector('#introformSC').style.display = 'none';
        });
      }
      document.querySelector('#categoriesSC span.categorySC').click();
      const itemsArr2 = document.querySelectorAll('span.subcategorySC');
      for (let index2 = 0; index2 < itemsArr2.length; index2++) {
        itemsArr2[index2].addEventListener('click', function (e) {
          if (e.target.getAttribute('data-id') == 140) {
            document.location.replace('https://www.aroma-zone.com/content/recrutement');
            return;
          }
          document.querySelector('#introformSC').style.display = 'block';
          if (document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_'))) {
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'none';
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'block';
            document.querySelector('#textFaqintroformSC').style.display = 'block';
          } else {
            document.querySelector('#textFaqintroformSC').style.display = 'none';
          }
          document.querySelector('#easiformarea').style.display = 'block';
          classHide(document.querySelectorAll('.subcategorySC'));
          document.querySelector('#easi_fielddiv_Category').style.display = 'none';
          document.querySelector('#easi_fielddiv_SubCategory').style.display = 'none';

          e.target.style.display = 'block';
          window.scrollTo(
            0,
            Math.round(
              window.scrollY + document.querySelector('#introformSC').getBoundingClientRect().top * zoomMobile,
            ),
          );
          document
            .querySelector('#fld_SubCategory')
            .add(new Option(e.target.getAttribute('label'), e.target.getAttribute('data-id')));
          document.easiform.fld_SubCategory.value = e.target.getAttribute('data-id');
          const fld_SubCategory = e.target.getAttribute('data-id');
          arrsCatFields.forEach(function (s) {
            if (s.fSubCategory == fld_SubCategory) {
              if (s.OrderId == 1) {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'none';
              }
              if (s.Product1MagentoCode == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'none';
              }
              if (s.Product1NameAndCapacity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'none';
              }
              if (s.Product1Batch == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'none';
              }
              if (s.Product1Quantity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'none';
              }
              if (s.Catalog == 1) {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'none';
              }
              if (s.MediaNotes == 1) {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'none';
              }
            }
          });
        });
      }
    }
  },

  de(user) {
    const checkExist = setInterval(function () {
      if (document.querySelectorAll('.easiform').length) {
        document.easiform.fld_CS_RequestObject.value = '';
        document.easiform.fld_CS_OrderId.value = '';
        document.easiform.fld_CS_Product1MagentoCode.value = '';
        document.easiform.fld_CS_Product1NameAndCapacity.value = '';
        document.easiform.fld_CS_Product1Batch.value = '';
        document.easiform.fld_CS_Product1Quantity.value = '';
        document.easiform.fld_CS_Catalog.value = '';
        document.easiform.fld_CS_MediaNotes.value = '';
        document.querySelector('#easi_fieldlabel_FirstName').textContent = 'Vorname';
        document.querySelector('#easi_fieldlabel_LastName').textContent = 'Nachname';
        document.querySelector('#easi_fieldlabel_Email').textContent = 'Email';
        document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Titel der Anfrage';
        document.querySelector('#easi_fieldlabel_Description').textContent = 'Beschreibung';
        document.querySelector('#easi_fieldlabel_CS_OrderId').textContent = 'Bestellnummer';
        document.querySelector('#easi_fieldlabel_CS_Product1MagentoCode').textContent = 'Produktreferenz (SKU)';
        document.querySelector('#easi_fieldlabel_CS_Product1NameAndCapacity').textContent = 'Produktname';
        document.querySelector('#easi_fieldlabel_CS_Product1Batch').textContent = 'Produktchargennummer';
        document.querySelector('#easi_fieldlabel_CS_Product1Quantity').textContent = 'Produktmenge';
        document.querySelector('#easi_fieldlabel_AttachedFiles').textContent = 'Angehängte Dokumente';
        document.querySelector('#easi_fieldlabel_CS_MediaNotes').textContent = 'Website / Soziales Netzwerk';
        document.querySelector('#validatebutton').textContent = 'Anfrage senden';
        document.querySelector('#mandatoryfieldmention').textContent = '* Benötigte Felder';
        authUserFields(user);
        document.easiform.fld_Description.setAttribute('maxlength', '500');
        document
          .querySelector('#validatebutton')
          .insertAdjacentHTML(
            'beforeBegin',
            '<button id="validatebuttonTemp" class="validatebutton">' +
              document.querySelector('#validatebutton').textContent +
              '</button>',
          );
        document.querySelector('#validatebutton').style.display = 'none';
        document.getElementById('validatebuttonTemp').addEventListener('click', function (e) {
          const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,25})+$/;
          if (
            document.easiform.fld_Email.value.match(mailformat) &&
            document.easiform.fld_FirstName.value != '' &&
            document.easiform.fld_LastName.value != '' &&
            document.easiform.fld_CS_RequestObject.value != '' &&
            document.easiform.fld_Description.value != ''
          ) {
            const userData = {
              email: document.easiform.fld_Email.value,
              firstName: document.easiform.fld_FirstName.value,
              lastName: document.easiform.fld_LastName.value,
              requestObject: document.easiform.fld_CS_RequestObject.value,
              description: document.easiform.fld_Description.value,
            };

            gtmPushEvent('form', {
              event_category: 'form',
              event_action: 'submit',
              event_label: 'submit_contact',
              event_name: 'submit_contact',
              user_data: userData,
            });

            if (document.easiform.fld_CS_OrderId.value != '') {
              document.easiform.fld_CS_RequestObject.value =
                'Ordine : ' +
                document.easiform.fld_CS_OrderId.value +
                ' / ' +
                document.easiform.fld_CS_RequestObject.value;
            }
            if (document.easiform.fld_CS_Product1NameAndCapacity.value != '') {
              document.easiform.fld_Description.value =
                'Articolo : ' +
                document.easiform.fld_CS_Product1NameAndCapacity.value +
                ' /\r\n ' +
                document.easiform.fld_Description.value;
            }
            document.querySelector('#validatebuttonTemp').style.display = 'none';
            document.querySelector('#validatebutton').click();
            document.querySelector('#introSC').style.display = 'none';
            document.querySelector('#categoriesSC').style.display = 'none';
            document.querySelector('#subcategoriesSC').style.display = 'none';
            document.querySelector('#introsubcatSC').style.display = 'none';
            document.querySelector('#introformSC').style.display = 'none';
            window.history.replaceState(null, null, '?form=sent');
            document.querySelector('#easiformmessages').textContent = '';
          } else {
            document.querySelector('#easiformmessages').textContent =
              '⚠ Bitte füllen Sie die Pflichtfelder (*) aus, damit Ihre Anfrage berücksichtigt werden kann';
          }
        });
        clearInterval(checkExist);
      }
    }, 100);

    const Cat = '[{"fCategory":"165","NameFR":"Deutsche Anfragen"}]';
    if (document.readyState !== 'loading') {
      const sCat =
        '[{"fSubCategory":"166","NameFR":"Ich habe eine Frage zur Lieferung oder Rückgabe meiner Bestellung","Parent":"165"},{"fSubCategory":"167","NameFR":"Ich habe meine Bestellung erhalten, aber etwas stimmt nicht","Parent":"165"},{"fSubCategory":"168","NameFR":"Ich habe Fragen zu meinem Produkt","Parent":"165"},{"fSubCategory":"169","NameFR":"Ich brauche Hilfe","Parent":"165"},{"fSubCategory":"170","NameFR":"Ich habe ein berufliches Bedürfnis","Parent":"165"},{"fSubCategory":"171","NameFR":"Ich benötige Hilfe auf der Website oder im Geschäft","Parent":"165"},{"fSubCategory":"172","NameFR":"Ich habe eine Frage zur Marke","Parent":"165"}]';
      const sCatFields =
        '[{"fSubCategory":"166","OrderId":"1","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"167","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"0"},{"fSubCategory":"168","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"169","OrderId":"0","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"170","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"171","OrderId":"1","Product1MagentoCode":"1","Product1NameAndCapacity":"1","Product1Batch":"1","Product1Quantity":"1","Catalog":"0","MediaNotes":"1"},{"fSubCategory":"172","OrderId":"0","Product1MagentoCode":"0","Product1NameAndCapacity":"0","Product1Batch":"0","Product1Quantity":"0","Catalog":"0","MediaNotes":"1"}]';
      const arrCat = JSON.parse(Cat);
      const arrsCat = JSON.parse(sCat);
      const arrsCatFields = JSON.parse(sCatFields);
      arrCat.forEach(function (c) {
        document
          .querySelector('#categoriesSC')
          .insertAdjacentHTML(
            'beforeend',
            '<span class="categorySC" id="categorySC' +
              c.fCategory +
              '" data-id="' +
              c.fCategory +
              '" label="' +
              c.NameFR +
              '">' +
              c.NameFR +
              '</span>',
          );
        document
          .querySelector('#subcategoriesSC')
          .insertAdjacentHTML('beforeend', '<div class="sbcategoriesSC" id="subcategorySC' + c.fCategory + '" ></div>');
      });
      arrsCat.forEach(function (s) {
        document
          .querySelector('#subcategorySC' + s.Parent)
          .insertAdjacentHTML(
            'beforeend',
            '<span class="subcategorySC" id="subcategorySC' +
              s.fSubCategory.replace('.', '_') +
              '" data-id="' +
              s.fSubCategory +
              '" label="' +
              s.NameFR +
              '" style="display:none;">' +
              s.NameFR +
              '</span>',
          );
        if (s.Articles) {
          document
            .querySelector('#introformSC')
            .insertAdjacentHTML(
              'beforeend',
              '<ul class="articlesSC" id="articlesSC' + s.fSubCategory.replace('.', '_') + '"></ul>',
            );
          s.Articles.forEach(function (a) {
            document
              .querySelector('#articlesSC' + s.fSubCategory.replace('.', '_'))
              .insertAdjacentHTML(
                'beforeend',
                '<li class="articleSC" id="kbid_' +
                  a.kbid +
                  '"><a href="' +
                  a.url +
                  '" target="_blank">' +
                  a.title.replace(' ?', '&nbsp;?') +
                  '</a></li>',
              );
          });
        }
      });

      document.querySelector('#categoriesSC').style.display = 'block';
      const scategoriesSC = document.getElementById('categoriesSC').children;
      for (let i = 0; i < scategoriesSC.length; i++) {
        scategoriesSC[i].style.display = 'block';
      }
      document.querySelector('#introSC').style.display = 'none';
      document.querySelector('#categoriesSC').style.display = 'none';
      const zoomMobile = 1;
      document.querySelector('#introsubcatSC').addEventListener('click', (e) => {
        classHide(document.querySelectorAll('.articlesSC'));
        classShow(document.querySelectorAll('.categorySC'));
        classShow(document.querySelectorAll('span.subcategorySC'));
        document.querySelector('#introformSC').style.display = 'none';
        document.querySelector('#easiformarea').style.display = 'none';
      });
      const itemsArr = document.querySelectorAll('span.categorySC');
      for (let index = 0; index < itemsArr.length; index++) {
        itemsArr[index].addEventListener('click', function (e) {
          document.querySelector('#introsubcatSC').style.display = 'block';
          document.querySelector('#easiformarea').style.display = 'none';
          classHide(document.querySelectorAll('.articlesSC'));
          classHide(document.querySelectorAll('.categorySC'));
          e.target.style.display = 'block';
          document.querySelector('#sub' + e.target.getAttribute('id')).style.display = 'block';
          const subcategoriesSC = document.getElementById('sub' + e.target.getAttribute('id')).childNodes;
          for (let i = 0; i < subcategoriesSC.length; i++) {
            subcategoriesSC[i].style.display = 'none';
            subcategoriesSC[i].style.display = 'block';
          }
          if (document.getElementById('fld_Category')) {
            document.getElementById('fld_Category').value = e.target.getAttribute('data-id');
          }
          document.querySelector('#introformSC').style.display = 'none';
        });
      }
      document.querySelector('#categoriesSC span.categorySC').click();
      const itemsArr2 = document.querySelectorAll('span.subcategorySC');
      for (let index2 = 0; index2 < itemsArr2.length; index2++) {
        itemsArr2[index2].addEventListener('click', function (e) {
          if (e.target.getAttribute('data-id') == 140) {
            document.location.replace('https://www.aroma-zone.com/content/recrutement');
            return;
          }
          document.querySelector('#introformSC').style.display = 'block';
          if (document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_'))) {
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'none';
            document.querySelector('#articlesSC' + e.target.getAttribute('data-id').replace('.', '_')).style.display =
              'block';
            document.querySelector('#textFaqintroformSC').style.display = 'block';
          } else {
            document.querySelector('#textFaqintroformSC').style.display = 'none';
          }
          document.querySelector('#easiformarea').style.display = 'block';
          classHide(document.querySelectorAll('.subcategorySC'));
          document.querySelector('#easi_fielddiv_Category').style.display = 'none';
          document.querySelector('#easi_fielddiv_SubCategory').style.display = 'none';

          e.target.style.display = 'block';
          window.scrollTo(
            0,
            Math.round(
              window.scrollY + document.querySelector('#introformSC').getBoundingClientRect().top * zoomMobile,
            ),
          );
          document
            .querySelector('#fld_SubCategory')
            .add(new Option(e.target.getAttribute('label'), e.target.getAttribute('data-id')));
          document.easiform.fld_SubCategory.value = e.target.getAttribute('data-id');
          const fld_SubCategory = e.target.getAttribute('data-id');
          arrsCatFields.forEach(function (s) {
            if (s.fSubCategory == fld_SubCategory) {
              if (s.OrderId == 1) {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_OrderId').style.display = 'none';
              }
              if (s.Product1MagentoCode == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1MagentoCode').style.display = 'none';
              }
              if (s.Product1NameAndCapacity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1NameAndCapacity').style.display = 'none';
              }
              if (s.Product1Batch == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Batch').style.display = 'none';
              }
              if (s.Product1Quantity == 1) {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Product1Quantity').style.display = 'none';
              }
              if (s.Catalog == 1) {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_Catalog').style.display = 'none';
              }
              if (s.MediaNotes == 1) {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'table';
              } else {
                document.querySelector('#easi_fielddiv_CS_MediaNotes').style.display = 'none';
              }
            }
          });
        });
      }
    }
  },

  base(user, locale = {}) {
    const checkExist = setInterval(function () {
      if (document.querySelectorAll('.easiform').length) {
        document.querySelector('#easiformarea').style.display = 'block';
        document.querySelector('#easi_fielddiv_Category').style.display = 'none';
        document.querySelector('#easi_fielddiv_SubCategory').style.display = 'none';
        document.easiform.fld_CS_RequestObject.value = '';
        document.easiform.fld_Category.value = '146';
        document.easiform.fld_SubCategory.value = '155';
        document.querySelector('#fld_SubCategory').add(new Option('Commentaires nouveau site 2023', 155, true, true));
        document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Titre de votre commentaire';
        document.querySelector('#easi_labelspan_AttachedFiles').textContent = "Pièces jointes / capture d'écran";
        if (locale === 'it') {
          document.querySelector('#easi_fieldlabel_FirstName').textContent = 'Cognome';
          document.querySelector('#easi_fieldlabel_LastName').textContent = 'Nome';
          document.querySelector('#easi_fieldlabel_Email').textContent = 'Email';
          document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Titolo della domanda';
          document.querySelector('#easi_fieldlabel_Description').textContent = 'Descrizione';
          document.querySelector('#easi_labelspan_AttachedFiles').textContent = 'Allegati / screenshot';
          document.querySelector('#mandatoryfieldmention').textContent = '* Campi obbligatori';
          document.querySelector('#validatebutton').textContent = 'Invia il mio commento';
        }
        if (locale === 'en') {
          document.querySelector('#easi_fieldlabel_FirstName').textContent = 'First Name';
          document.querySelector('#easi_fieldlabel_LastName').textContent = 'Last Name';
          document.querySelector('#easi_fieldlabel_Email').textContent = 'Email';
          document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Request title';
          document.querySelector('#easi_fieldlabel_Description').textContent = 'Description';
          document.querySelector('#easi_labelspan_AttachedFiles').textContent = 'Attached files';
          document.querySelector('#mandatoryfieldmention').textContent = '* Required fields';
          document.querySelector('#validatebutton').textContent = 'Send Request';
        }
        if (locale === 'es') {
          document.querySelector('#easi_fieldlabel_FirstName').textContent = 'Nombre';
          document.querySelector('#easi_fieldlabel_LastName').textContent = 'Apellido';
          document.querySelector('#easi_fieldlabel_Email').textContent = 'Correo electrónico';
          document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Título';
          document.querySelector('#easi_fieldlabel_Description').textContent = 'Descripción';
          document.querySelector('#easi_labelspan_AttachedFiles').textContent = 'Archivos añadidos ';
          document.querySelector('#mandatoryfieldmention').textContent = '* Campos obligatorios';
          document.querySelector('#validatebutton').textContent = 'Enviar solicitud';
        }
        if (locale === 'de') {
          document.querySelector('#easi_fieldlabel_FirstName').textContent = 'Vorname';
          document.querySelector('#easi_fieldlabel_LastName').textContent = 'Nachname';
          document.querySelector('#easi_fieldlabel_Email').textContent = 'Email';
          document.querySelector('#easi_fieldlabel_CS_RequestObject').textContent = 'Titel der Anfrage';
          document.querySelector('#easi_fieldlabel_Description').textContent = 'Beschreibung';
          document.querySelector('#easi_labelspan_AttachedFiles').textContent = 'Angehängte Dokumente';
          document.querySelector('#mandatoryfieldmention').textContent = '* Benötigte Felder';
          document.querySelector('#validatebutton').textContent = 'Anfrage senden';
        }
        authUserFields(user);
        document.easiform.fld_Description.setAttribute('maxlength', '502');
        document
          .querySelector('#validatebutton')
          .insertAdjacentHTML(
            'beforeBegin',
            '<button id="validatebuttonTemp" class="validatebutton">' +
              document.querySelector('#validatebutton').textContent +
              '</button>',
          );
        document.querySelector('#validatebutton').style.display = 'none';
        document.getElementById('validatebuttonTemp').addEventListener('click', function (e) {
          const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,25})+$/;
          if (
            document.easiform.fld_Email.value.match(mailformat) &&
            document.easiform.fld_FirstName.value != '' &&
            document.easiform.fld_LastName.value != '' &&
            document.easiform.fld_CS_RequestObject.value != '' &&
            document.easiform.fld_Description.value != ''
          ) {
            document.querySelector('#validatebuttonTemp').style.display = 'none';
            document.querySelector('#validatebutton').click();
            document.querySelector('#introSC').style.display = 'none';
            document.querySelector('#categoriesSC').style.display = 'none';
            document.querySelector('#subcategoriesSC').style.display = 'none';
            document.querySelector('#introsubcatSC').style.display = 'none';
            document.querySelector('#introformSC').style.display = 'none';
            window.scrollTo(0, 0);
            window.history.replaceState(null, null, '?form=sent');
          } else if (locale === 'it') {
            document.querySelector('#easiformmessages').textContent =
              '⚠Compila tutti i campi obbligatori (*) per permetterci di prendere in carico la tua richiesta, grazie';
          } else if (locale === 'en') {
            document.querySelector('#easiformmessages').textContent =
              '⚠Please fill in the required fields (*) in order to take your request into account';
          } else if (locale === 'es') {
            document.querySelector('#easiformmessages').textContent =
              '⚠Por favor, rellene los campos obligatorios (*) para tener en cuenta su solicitud';
          } else if (locale === 'de') {
            document.querySelector('#easiformmessages').textContent =
              '⚠Bitte füllen Sie die Pflichtfelder (*) aus, damit Ihre Anfrage berücksichtigt werden kann';
          } else {
            document.querySelector('#easiformmessages').textContent =
              '⚠Veuillez saisir les champs obligatoires (*) afin de prendre en compte votre demande';
          }
        });
        clearInterval(checkExist);
      }
    }, 100);
  },
};

export { contactForm };
